__webpack_require__.p = "/kalai-react-portfolio/";